var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { trackPinch, trackPinchConversion } from "./analytics/events.mjs";
class Pinch {
  constructor(storage) {
    __publicField(this, "breadcrumbs", []);
    __publicField(this, "conversionCountsByResource", {});
    __publicField(this, "latestPinchesByResource", {});
    __publicField(this, "sessionPinchCount", 0);
    __publicField(this, "sessionPerResourcePinchCounts", {});
    this.storage = storage;
  }
  trackPinch(opts) {
    const { resource, trigger, ...extraAnalytics } = opts;
    this.sessionPinchCount = (this.sessionPinchCount || 0) + 1;
    this.sessionPerResourcePinchCounts[resource] = (this.sessionPerResourcePinchCounts[resource] || 0) + 1;
    this.storage.assign((storage) => {
      storage.trackPinchAllTimeCount = (this.storage.trackPinchAllTimeCount || 0) + 1;
      storage.trackPinchAllTimeCounts[resource] = (this.storage.trackPinchAllTimeCounts[resource] || 0) + 1;
    });
    const pinchEvent = {
      allTimeCount: this.storage.trackPinchAllTimeCount,
      allTimeCountForResource: this.storage.trackPinchAllTimeCounts[resource],
      resource,
      sessionCount: this.sessionPinchCount,
      sessionCountForResource: this.sessionPerResourcePinchCounts[resource],
      trigger
    };
    trackPinch({ ...pinchEvent, ...extraAnalytics });
    this.breadcrumbs = [...this.breadcrumbs.slice(-4), trigger];
    this.latestPinchesByResource[resource] = pinchEvent;
  }
  trackPinchConversion(opts) {
    const {
      action,
      feature,
      resource,
      subFeature,
      wasSurfacedByPinch,
      ...extraAnalytics
    } = opts;
    if (!this.conversionCountsByResource[resource]) {
      this.conversionCountsByResource[resource] = 0;
    }
    this.conversionCountsByResource[resource]++;
    const associatedPinch = this.latestPinchesByResource[resource];
    const commonEventProps = {
      ...extraAnalytics,
      action,
      breadcrumbs: this.breadcrumbs.join(";") || void 0,
      conversionCount: this.conversionCountsByResource[resource],
      feature,
      resource,
      subFeature,
      wasSurfacedByPinch
    };
    if (!associatedPinch) {
      trackPinchConversion({
        ...commonEventProps,
        pinchAssociated: false
      });
    } else {
      trackPinchConversion({
        ...commonEventProps,
        pinchAllTimeCount: associatedPinch.allTimeCount,
        pinchAllTimeCountForResource: associatedPinch.allTimeCountForResource,
        pinchAssociated: true,
        pinchSessionCount: associatedPinch.sessionCount,
        pinchSessionCountForResource: associatedPinch.sessionCountForResource,
        pinchTrigger: associatedPinch.trigger
      });
    }
  }
}
export {
  Pinch
};
